import React, { useContext } from "react";
import dataText from "./data";
import * as S from "./InstructionStyle";
import ButtonsGroup from "../ButtonsGroup/ButtonsGroup";
import { AppContext } from "../../AppContext";

const Instructions = (props) => {
  const { data } = useContext(AppContext);

  return (
    <S.Container>
      <S.Title>{dataText.title}</S.Title>
      {!data.isImageTest ? (
        <>
          <S.Text>{dataText.textA}</S.Text>
          <S.Text>{dataText.textB}</S.Text>
          <S.Text>{dataText.textC}</S.Text>
          <S.Text>{dataText.textD}</S.Text>
          <S.Text>{dataText.textE}</S.Text>
        </>
      ) : (
        <>
          <S.Text>{dataText.textImageA}</S.Text>
          <S.Text>{dataText.textImageB}</S.Text>
          <S.Text>{dataText.textImageC}</S.Text>
          <S.Text>{dataText.textImageD}</S.Text>
          <S.Text>{dataText.textImageE}</S.Text>
        </>
      )}
      <ButtonsGroup
        onForwardBtnClick={props.onForwardBtnClick}
        onBackBtnClick={props.onBackBtnClick}
      />
    </S.Container>
  );
};

export default Instructions;
